/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkClaimContactRequest
 */
export interface LinkClaimContactRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkClaimContactRequest
     */
    contactId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkClaimContactRequest
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof LinkClaimContactRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the LinkClaimContactRequest interface.
 */
export function instanceOfLinkClaimContactRequest(value: object): value is LinkClaimContactRequest {
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function LinkClaimContactRequestFromJSON(json: any): LinkClaimContactRequest {
    return LinkClaimContactRequestFromJSONTyped(json, false);
}

export function LinkClaimContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkClaimContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'],
        'role': json['role'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function LinkClaimContactRequestToJSON(json: any): LinkClaimContactRequest {
    return LinkClaimContactRequestToJSONTyped(json, false);
}

export function LinkClaimContactRequestToJSONTyped(value?: LinkClaimContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactId': value['contactId'],
        'role': value['role'],
        'notes': value['notes'],
    };
}

